$(document).ready(() => {

  $(".navigation-container .has-dropdown a").not(".child-item a").each(function (index) {
    $(this).on("click", function (e) {
      e.preventDefault();
      let subMenu = $(this).parent().find(".child-menu");

      let previousOpenMenus = $(this).parent().parent().find("a[aria-expanded]");

      // Closes all currently open dropdowns.
      previousOpenMenus.not(this).each(function() {
        if ($(this).attr("aria-expanded") === "true") {
          $(this).attr("aria-expanded", (_,a) => a === "false" || false ? "true" : "false");
          $(this).parent().find(".child-menu").toggleClass('hidden');
        }
      })

      $(this).attr("aria-expanded", (_,a) => a === "false" || false ? "true" : "false");
      $(subMenu).toggleClass('hidden');

    });
  });

// Shows the primary menu overlay
  $(".mobile-navigation-wrapper").find(".mobile-menu-toggle").click(function () {
    // Allow the body to scroll again.
    $('body').toggleClass('overflow-hidden');

    $(".primary-mobile-menu-overlay").toggleClass('hidden')
  })

// Shows the contact menu overlay
  $(".mobile-navigation-wrapper").find(".contact-menu-toggle").click(function () {
    // Allow the body to scroll again.
    $('body').toggleClass('overflow-hidden');

    $(".mobile-contact-menu-overlay").toggleClass('hidden')
    $(".primary-mobile-menu-overlay").toggleClass('hidden')
  })
// Hides the primary menu overlay
  $(".primary-mobile-menu-overlay-header").find(".mobile-menu-toggle").click(function () {
    // Make sure the body is not scrollable.
    $('body').removeClass('overflow-hidden');

    $(".primary-mobile-menu-overlay").addClass('hidden')
  })

// Hides the contact menu overlay
  $(".mobile-contact-menu-overlay-header").find(".mobile-menu-toggle").click(function () {
    // Make sure the body is not scrollable.
    $('body').removeClass('overflow-hidden');

    // Add the hidden class if contact overlay is showing
    if (!$(".mobile-contact-menu-overlay").hasClass('hidden')) {
      $(".mobile-contact-menu-overlay").addClass('hidden')
    }
  })

// Language Switcher
// Hides the contact menu overlay
  $("#language-switcher").find("#language-menu-toggle").not("#language-dropdown a").click(function (e) {
    e.preventDefault();
    $("#language-dropdown").toggleClass('hidden')
  })

// Setup the jQuery drilldown menu plugin.
  $('.drilldown').drilldown({ speed: 300 });

});
